import { create } from 'zustand';

/**
 * Global open/close state for the standalone Integrations popup launched from
 * the Dock / SlimCreatePalette "Integrations" app entry (see `DOCK_APPS` in
 * `pinnedApps.ts`). Mirrors `slimCreatePaletteStore`'s pattern — a single
 * `<IntegrationsPopup>` instance is mounted once in `DesktopShell` and driven
 * by this store, rather than each launch site owning its own local state.
 *
 * Other call sites (ChatHeader, ContextSelector, IntegrationAddPill, etc.)
 * still mount their own local `<IntegrationsPopup>` instance directly — this
 * store only backs the Dock/palette "regular app" launcher entry point.
 */
interface IntegrationsPopupStore {
  isOpen: boolean;
  focusSlug: string | null;
  open: (opts?: { focusSlug?: string }) => void;
  close: () => void;
}

export const useIntegrationsPopupStore = create<IntegrationsPopupStore>((set) => ({
  isOpen: false,
  focusSlug: null,
  open: (opts) => set({ isOpen: true, focusSlug: opts?.focusSlug ?? null }),
  close: () => set({ isOpen: false, focusSlug: null }),
}));
